import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { appRoutes } from '../../../routes/routes';
import { subscribeToJiraStatus } from '../../../services/jira';
import styles from './JiraTile.module.scss';

export const JiraTile = () => {
  const companyId = useSelector(
    (s) => s.auth.profile?.activeCompany?.companyId
  );
  const history = useHistory();
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!companyId) return;
    const unsub = subscribeToJiraStatus(companyId, (status) =>
      setConnected(status.connected)
    );
    return unsub;
  }, [companyId]);

  return (
    <div
      className={styles.tile}
      onClick={() => history.push(appRoutes().integrationsJira)}
      role="button"
      tabIndex={0}
      onKeyDown={(e) =>
        e.key === 'Enter' && history.push(appRoutes().integrationsJira)
      }
    >
      <div className={styles.logo}>J</div>
      <div className={styles.body}>
        <div className={styles.titleRow}>
          <span className={styles.name}>Jira</span>
          <span
            className={`${styles.badge} ${connected ? styles.connected : styles.disconnected}`}
          >
            {connected ? 'Connected' : 'Not Connected'}
          </span>
        </div>
        <p className={styles.description}>
          Import Jira project tasks into Prodaff for unified task management.
        </p>
      </div>
      <div className={styles.arrow}>›</div>
    </div>
  );
};
